import { render, staticRenderFns } from "./emojiInput.vue?vue&type=template&id=f674300e"
import script from "./emojiInput.vue?vue&type=script&lang=js"
export * from "./emojiInput.vue?vue&type=script&lang=js"
import style0 from "./emojiInput.vue?vue&type=style&index=0&id=f674300e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports